import { schema } from 'normalizr';

export const businessSchema = new schema.Entity('business', {}, { idAttribute: 'publicId' });
